module.exports = __webpack_public_path__ + "img/图片22.b9d6df18.png";